import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTelegram } from '../hooks/useTelegram';
import './CheckoutSuccessPage.css';

export const CheckoutSuccessPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('orderId');
  const { tg } = useTelegram();

  useEffect(() => {
    // Hide back button on success page
    if (tg?.BackButton) {
      tg.BackButton.hide();
    }
  }, [tg]);

  const handleTrackOrder = () => {
    if (orderId) {
      navigate(`/orders/${orderId}`, { replace: true });
    } else {
      navigate('/orders', { replace: true });
    }
  };

  const handleGoHome = () => {
    navigate('/', { replace: true });
  };

  return (
    <div className="page checkout-success-page">
      <div className="success-content">
        <div className="success-icon">
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
            <circle cx="40" cy="40" r="40" fill="#4CAF50" opacity="0.1"/>
            <circle cx="40" cy="40" r="32" fill="#4CAF50" opacity="0.2"/>
            <path d="M25 40L35 50L55 30" stroke="#4CAF50" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>

        <h1 className="success-title">Заказ успешно оформлен!</h1>

        <div className="success-message">
          <p>В ближайшее время с вами свяжется менеджер для подтверждения и оплаты заказа.</p>
          <p>Вы можете отследить статус заказа в личном кабинете.</p>
        </div>

        {orderId && (
          <div className="order-number">
            <span className="order-number-label">Номер заказа:</span>
            <span className="order-number-value">#{orderId}</span>
          </div>
        )}

        <a
          href="https://t.me/TESTORIA_Mosk"
          target="_blank"
          rel="noopener noreferrer"
          className="contact-manager-link"
        >
          💬 Связаться с менеджером
        </a>

        <div className="success-actions">
          <button className="success-button primary" onClick={handleTrackOrder}>
            Отследить заказ
          </button>
          <button className="success-button secondary" onClick={handleGoHome}>
            Вернуться на главную
          </button>
        </div>
      </div>
    </div>
  );
};
